module.exports = __webpack_public_path__ + "static/img/section-3.a76560d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/section-3.jpg
// module id = YC7a
// module chunks = 1